import React from "react";
import { Link } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";

const StaffAugmentation = () => {
  return (
    <div className="bg-gray-100 min-h-screen">
      <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <h1 className="text-4xl font-bold mb-8 text-gray-800">
          Staff Augmentation
        </h1>
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex items-center mb-4">
            <Users className="w-12 h-12 text-red-500 mr-4" />
            <p className="text-xl text-gray-700">
              Supplement your existing team with additional expertise.
            </p>
          </div>
          <p className="text-gray-600 mb-4">
            Our Staff Augmentation service allows you to quickly scale your team
            with skilled professionals. Whether you need to fill skill gaps or
            handle increased workload, we provide the right talent to seamlessly
            integrate with your existing team.
          </p>
          <h2 className="text-2xl font-semibold mb-4 text-gray-800">
            How It Works
          </h2>
          <ol className="list-decimal list-inside mb-6 text-gray-700">
            <li className="mb-2">
              We assess your team's current capabilities and needs
            </li>
            <li className="mb-2">
              Our recruiters source professionals with complementary skills
            </li>
            <li className="mb-2">You review and select the best candidates</li>
            <li className="mb-2">Selected professionals join your team</li>
            <li>We provide ongoing support and performance monitoring</li>
          </ol>
          <Link
            to="/contact"
            className="bg-blue-600 text-white px-6 py-3 rounded-lg hover:bg-blue-700 transition-colors inline-flex items-center text-lg font-semibold"
          >
            Get Started <ArrowRight className="ml-2 w-5 h-5" />
          </Link>
        </div>
      </main>
    </div>
  );
};

export default StaffAugmentation;
